var _g, _g2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.30029,
    y: -1.75,
    width: 13,
    height: 13
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_8522_3912_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8522_3912)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80029 7.25C11.181 7.25 12.3003 6.13071 12.3003 4.75C12.3003 3.36929 11.181 2.25 9.80029 2.25C8.41958 2.25 7.30029 3.36929 7.30029 4.75C7.30029 6.13071 8.41958 7.25 9.80029 7.25Z",
    fill: "#7947C9"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.68848,
    y: 0.984375,
    width: 24.9775,
    height: 17.0312
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_8522_3912_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8522_3912)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80022 4.98438C14.6202 4.98438 18.0622 8.76034 18.2884 13.5156C18.3015 13.7914 18.0763 14.0156 17.8002 14.0156H1.80022C1.52408 14.0156 1.29895 13.7914 1.31207 13.5156C1.53818 8.76034 4.98018 4.98438 9.80022 4.98438Z",
    fill: "#8D73DC",
    fillOpacity: 0.6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 20,
    height: 4,
    rx: 1,
    fill: "#7421F9",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8522_3912",
    x: 3.30029,
    y: -1.75,
    width: 13,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8522_3912"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_8522_3912_clip_path",
    transform: "translate(-3.30029 1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80029 7.25C11.181 7.25 12.3003 6.13071 12.3003 4.75C12.3003 3.36929 11.181 2.25 9.80029 2.25C8.41958 2.25 7.30029 3.36929 7.30029 4.75C7.30029 6.13071 8.41958 7.25 9.80029 7.25Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8522_3912",
    x: -2.68848,
    y: 0.984375,
    width: 24.9775,
    height: 17.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8522_3912"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_8522_3912_clip_path",
    transform: "translate(2.68848 -0.984375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80022 4.98438C14.6202 4.98438 18.0622 8.76034 18.2884 13.5156C18.3015 13.7914 18.0763 14.0156 17.8002 14.0156H1.80022C1.52408 14.0156 1.29895 13.7914 1.31207 13.5156C1.53818 8.76034 4.98018 4.98438 9.80022 4.98438Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastFood);
export default __webpack_public_path__ + "static/media/fastFood.2d64872feb0397bcf31b80c7be98739c.svg";
export { ForwardRef as ReactComponent };